import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { StudentProfile } from '../../../lib/database.types';
import '../OJTCoordinator.css';
import './ProgramStat.css';

// Card Component
interface ClassSectionsCardProps {
  count: number;
  onClick: () => void;
}

export const ClassSectionsCard: React.FC<ClassSectionsCardProps> = ({ count, onClick }) => {
  return (
    <div className="stat-card clickable" onClick={onClick}>
      <div className="stat-number">{count}</div>
      <div className="stat-label">Class Sections</div>
    </div>
  );
};

// Modal Component
interface ClassSectionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  studentsBySection: { [section: string]: StudentProfile[] };
}

export const ClassSectionsModal: React.FC<ClassSectionsModalProps> = ({ isOpen, onClose, studentsBySection }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content students-modal sections-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Students by Class Section</h2>
          <button className="close-modal-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          {Object.entries(studentsBySection).map(([section, sectionStudents]) => (
            <div key={section} className="section-group">
              <div className="section-header">
                <h3 className="section-title">{section}</h3>
                <span className="section-count">{sectionStudents.length} students</span>
              </div>
              <div className="students-table-container">
                <table className="students-table compact-table">
                  <thead>
                    <tr>
                      <th>Student ID</th>
                      <th>Name</th>
                      <th>Department</th>
                      <th>Supervisor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sectionStudents.map((student) => (
                      <tr key={student.id}>
                        <td>{student.student_id}</td>
                        <td>{student.first_name} {student.last_name}</td>
                        <td>{student.department}</td>
                        <td>{student.supervisor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

